// Ionic & Angular Imports
import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions} from '@angular/http';
import {Observable} from 'rxjs/observable';
import 'rxjs/add/operator/map';

export interface Photo {
    id: number;
    image: string;
    thumb: string; 
    notes: string;
}


@Injectable()
export class rsPhotoSvc 
{ 
    constructor(
        public http: Http, 
    ) {
        // Class constructor
    }

    getPhotos( reportId : number ) : Observable<Photo[]> {
        return Observable.create( observer => {
            this.http.get( 'http://dfr.hydrocon.com/api/v1/report/' + reportId + '/photo', {
                withCredentials: true 
            })
            .map( res => res.json().response.photos )
            .subscribe( result => {
                observer.next(result);
            }, err => {
                observer.error(err);
            }, () => {
                observer.complete();
            });
        });
    } 

    addPhoto( imageFile : File, notes: string, reportId : number ) : Observable<Photo> {
        return Observable.create( observer => 
        {
            // Instantiate some form data to attach to this request 
            let formData : FormData = new FormData();
            let xhr : XMLHttpRequest = new XMLHttpRequest();

            formData.append( "image", imageFile, imageFile.name );
            formData.append( "notes", notes );

            xhr.onreadystatechange = () => {
                if( xhr.readyState == 4 ) {
                    if( xhr.status == 200 || xhr.status == 201 ) {
                        observer.next( JSON.parse(xhr.response).response.photos);
                        observer.complete();
                    } else {
                        observer.error( xhr.response );
                    }
                }
            }

            // Open our request 
            xhr.open( "POST", "http://dfr.hydrocon.com/api/v1/report/" + reportId + "/photo", true );
            xhr.withCredentials = true;
            xhr.send( formData );
        });
    }

    updatePhoto( pictureId : number, notes: string, reportId : number ) : Observable<Photo> {
        return Observable.create( observer => {

            // Define patch data 
            let patchData = {
                notes: notes
            } ;

            let body = JSON.stringify(patchData);
            let headers = new Headers({
                'Content-Type' : 'application/json'
            });
            let options = new RequestOptions( { headers: headers, withCredentials: true } );
            this.http.patch( 'http://dfr.hydrocon.com/api/v1/report/' + reportId + '/photo/' + pictureId, body, options )
            .map( res => res.json().response.photos )
                .subscribe( result => {
                    observer.next(result);
                }, err => {
                    observer.error(err);
                }, () => {
                    observer.complete();
                });
        });
    }

    deletePhoto( pictureId : number, reportId : number ) : Observable<void> {
        return Observable.create( observer => {

            this.http.delete( 'http://dfr.hydrocon.com/api/v1/report/' + reportId + '/photo/' + pictureId, {
                withCredentials: true 
            })
            .map( res => res.json() )
            .subscribe( result => {
                observer.next( result );
            }, err => {
                observer.error(err);
            }, () => {
                observer.complete();
            });
        });
    }    
}


// WEBPACK FOOTER //
// ./src/services/photo.service.ts